import { ref, onMounted, nextTick } from 'vue'
import { useIndicateurTdbStore } from './useIndicateurTdbStore'
import { useScrollIntoView } from '@/features/interface/composables'
import { storeToRefs } from 'pinia'

export function useIndicateurTdbScroll() {
  const containerRef = ref<HTMLElement | null>(null)
  const currentIndex = ref(0)
  const showDots = ref(false)
  const store = useIndicateurTdbStore()
  const { documentCards } = storeToRefs(store)

  const { makeId, makeVisible } = useScrollIntoView()

  function checkScrollPossible() {
    nextTick(() => {
      const el = containerRef.value
      if (!el) return
      showDots.value = el.scrollWidth > el.clientWidth
    })
  }

  /**
   * Détecte quel est l'index de carte la plus proche du centre visible
   * du conteneur.
   */
  function onScroll() {
    const el = containerRef.value
    if (!el) return

    // Récupère la position "centre" du conteneur
    const containerRect = el.getBoundingClientRect()
    const containerCenter = containerRect.left + containerRect.width / 2

    let closestIndex = 0
    let minDistance = Infinity

    Object.keys(documentCards.value).forEach((_, index) => {
      const cardEl = document.getElementById(makeId(index))
      if (!cardEl) return

      const cardRect = cardEl.getBoundingClientRect()
      const cardCenter = cardRect.left + cardRect.width / 2
      const distance = Math.abs(cardCenter - containerCenter)

      if (distance < minDistance) {
        minDistance = distance
        closestIndex = index
      }
    })

    currentIndex.value = closestIndex
  }

  function scrollToIndex(i: number) {
    makeVisible(i)
    currentIndex.value = i
  }

  onMounted(() => {
    window.addEventListener('resize', checkScrollPossible)
    checkScrollPossible()
  })

  return {
    containerRef,
    currentIndex,
    showDots,
    onScroll,
    scrollToIndex,
    checkScrollPossible,
    makeId,
  }
}
